import { connect } from 'react-redux';
import { cancelSearch, goToNext, goToPrev } from '../../../../shared/actions/find';
import SearchControls from '../searchControls';
import setListContainerWidth from '../../../../shared/actions/setListContainerWidth';
import { SIDE_PANEL_TRANSITION } from '../../../constants';

const mapStateToProps = ({ find = {} }) => ({
  hasResults: !find.searchInProgress && !!find.matchCount,
  currentMatch: find.currentMatch,
  direction: find.direction,
  query: find.query,
});

const mapDispatchToProps = dispatch => ({
  goToNext: () => dispatch(goToNext()),
  goToPrev: () => dispatch(goToPrev()),
  cancelSearch: () => {
    dispatch(cancelSearch());
    setTimeout(() => dispatch(setListContainerWidth()), SIDE_PANEL_TRANSITION);
  },
});

export const SearchControlsContainer = connect(mapStateToProps, mapDispatchToProps)(SearchControls);
